import { render, staticRenderFns } from "./MobileHome.vue?vue&type=template&id=b6d8bbb0&scoped=true"
import script from "./MobileHome.vue?vue&type=script&lang=js"
export * from "./MobileHome.vue?vue&type=script&lang=js"
import style0 from "./MobileHome.vue?vue&type=style&index=0&id=b6d8bbb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d8bbb0",
  null
  
)

export default component.exports